if (!customElements.get('wlsn-5050-product-section')) {
  class WLSN5050ProductSection extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        tabs: 'js-wlsn-5050-product-section-tab',
        content: 'js-wlsn-5050-product-section-content',
      };

      this.elements = {
        tabs: this.querySelectorAll(`.${this.classes.tabs}`),
        contents: this.querySelectorAll(`.${this.classes.content}`),
      };
    }

    connectedCallback() {
      if (!this.elements.tabs.length || !this.elements.contents.length) return;

      this.elements.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.index;

          this.elements.tabs.forEach(t =>
            t.classList.remove(this.classes.activeClass)
          );

          this.elements.contents.forEach(c =>
            c.classList.remove(this.classes.visibleClass)
          );

          tab.classList.add(this.classes.activeClass);

          const activeContent = this.querySelector(
            `.${this.classes.content}[data-index="${index}"]`
          );

          if (activeContent) {
            activeContent.classList.add(this.classes.visibleClass);
          }
        });
      });
    }
  }

  customElements.define('wlsn-5050-product-section', WLSN5050ProductSection);
}
